import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { MomentModule } from 'ngx-moment';
import { PageGiftComponent } from '../components/page/page-gift.component';
import { BookApiService } from '../services/api/book.service';
import { CdApiService } from '../services/api/cd.service';
import { CertificateApiService } from '../services/api/certificate.service';
import { ChronicleApiService } from '../services/api/chronicle.service';
import { CoinApiService } from '../services/api/coin.service';
import { DvdApiService } from '../services/api/dvd.service';
import { FolderApiService } from '../services/api/folder.service';
import { MagazineApiService } from '../services/api/magazine.service';
import { NewspaperApiService } from '../services/api/newspaper.service';
import { RegionApiService } from '../services/api/region.service';
import { StickApiService } from '../services/api/stick.service';
import { YearBookApiService } from '../services/api/year-book.service';
import { ArticleFacade } from '../state/article/article.facade';
import { ArticleSelector } from '../state/article/article.selectors';
import { BookEffects } from '../state/book/book.effects';
import { BookFacade } from '../state/book/book.facade';
import { BookSelector } from '../state/book/book.selectors';
import { CdEffects } from '../state/cd/cd.effects';
import { CdFacade } from '../state/cd/cd.facade';
import { CdSelector } from '../state/cd/cd.selectors';
import { CertificateEffects } from '../state/certificate/certificate.effects';
import { CertificateFacade } from '../state/certificate/certificate.facade';
import { CertificateSelector } from '../state/certificate/certificate.selectors';
import { ChronicleEffects } from '../state/chronicle/chronicle.effects';
import { ChronicleFacade } from '../state/chronicle/chronicle.facade';
import { ChronicleSelector } from '../state/chronicle/chronicle.selectors';
import { CoinEffects } from '../state/coin/coin.effects';
import { CoinFacade } from '../state/coin/coin.facade';
import { CoinSelector } from '../state/coin/coin.selectors';
import { DvdEffects } from '../state/dvd/dvd.effects';
import { DvdFacade } from '../state/dvd/dvd.facade';
import { DvdSelector } from '../state/dvd/dvd.selectors';
import { FolderEffects } from '../state/folder/folder.effects';
import { FolderFacade } from '../state/folder/folder.facade';
import { FolderSelector } from '../state/folder/folder.selectors';
import { MagazineEffects } from '../state/magazine/magazine.effects';
import { MagazineFacade } from '../state/magazine/magazine.facade';
import { MagazineSelector } from '../state/magazine/magazine.selectors';
import { NewspaperEffects } from '../state/newspaper/newspaper.effects';
import { NewspaperFacade } from '../state/newspaper/newspaper.facade';
import { NewspaperSelector } from '../state/newspaper/newspaper.selectors';
import { RegionEffects } from '../state/region/region.effects';
import { RegionFacade } from '../state/region/region.facade';
import { RegionSelector } from '../state/region/region.selectors';
import { StickEffects } from '../state/stick/stick.effects';
import { StickFacade } from '../state/stick/stick.facade';
import { StickSelector } from '../state/stick/stick.selectors';
import { YearBookEffects } from '../state/year-book/year-book.effects';
import { YearBookFacade } from '../state/year-book/year-book.facade';
import { YearBookSelector } from '../state/year-book/year-book.selectors';
import { SharedModule } from './shared.module';

@NgModule({
	declarations: [PageGiftComponent],
	imports: [
		CommonModule,
		MomentModule,
		MatButtonModule,
		MatButtonToggleModule,
		MatCardModule,
		MatDatepickerModule,
		MatFormFieldModule,
		MatNativeDateModule,
		MatAutocompleteModule,
		MatIconModule,
		MatProgressSpinnerModule,
		MatProgressBarModule,
		MatInputModule,
		MatSelectModule,
		FormsModule,
		ReactiveFormsModule,
		EffectsModule.forFeature([NewspaperEffects, MagazineEffects, BookEffects, CoinEffects, ChronicleEffects, FolderEffects, StickEffects, CdEffects, DvdEffects, YearBookEffects, CertificateEffects, RegionEffects]),
		RouterModule.forChild([
			{
				path: '',
				component: PageGiftComponent,
			},
		]),
		SharedModule,
	],
	providers: [
		NewspaperApiService,
		NewspaperSelector,
		NewspaperFacade,

		MagazineApiService,
		MagazineSelector,
		MagazineFacade,

		BookApiService,
		BookSelector,
		BookFacade,

		CoinApiService,
		CoinSelector,
		CoinFacade,

		ChronicleApiService,
		ChronicleSelector,
		ChronicleFacade,

		FolderApiService,
		FolderSelector,
		FolderFacade,

		StickApiService,
		StickSelector,
		StickFacade,

		CdApiService,
		CdSelector,
		CdFacade,

		DvdApiService,
		DvdSelector,
		DvdFacade,

		YearBookApiService,
		YearBookSelector,
		YearBookFacade,

		CertificateApiService,
		CertificateSelector,
		CertificateFacade,

		RegionApiService,
		RegionSelector,
		RegionFacade,

		ArticleSelector,
		ArticleFacade,
	],
})
export class GiftpageModule {}
